import {
    ClientsService,
    TokensService,
} from '../services/clients'


export const ACTIONS = {
    FETCH_CLIENTS: 'fetchClients',
    PUT_CLIENTS: 'putClients',
    DEL_CLIENTS: 'delClients',
    UPDATE_CLIENTS: 'updateClients',

    FETCH_TOKENS: 'fetchTokens',
    DEL_TOKENS: 'delTokens',

    CLEAR_ERROR: 'clearError',
}


export const MUTATIONS = {
    FETCH_CLIENTS_START: 'fetchClientsStart',
    FETCH_CLIENTS_END: 'fetchClientsEnd',
    PUT_CLIENTS_START: 'putClientsStart',
    PUT_CLIENTS_END: 'putClientsEnd',
    PUT_CLIENTS_ERROR: 'putClientsError',
    DEL_CLIENTS_START: 'delClientsStart',
    DEL_CLIENTS_END: 'delClientsEnd',
    UPDATE_CLIENTS_START: 'updateClientsStart',
    UPDATE_CLIENTS_END: 'updateClientsEnd',
    UPDATE_CLIENTS_ERROR: 'updateClientsError',

    FETCH_TOKENS_START: 'fetchTokensStart',
    FETCH_TOKENS_END: 'fetchTokensEnd',
    DEL_TOKENS_START: 'delTokensStart',
    DEL_TOKENS_END: 'delTokensEnd',
}


const state = {
    clients: [],
    clientsIsLoading: false,
    addClientIsLoading: false,
    addClientError: '',
    globalLoader: false,
    successClient: '',

    tokens: [],
    tokensIsLoading: false,
}


const getters = {
    clients: ({ clients }) => clients,
    clientsIsLoading: ({ clientsIsLoading }) => clientsIsLoading,
    addClientIsLoading: ({ addClientIsLoading }) => addClientIsLoading,
    addClientError: ({ addClientError }) => addClientError,
    globalLoader: ({ globalLoader }) => globalLoader,
    successClient: ({ successClient }) => successClient,

    tokens: ({ tokens }) => tokens,
    tokensIsLoading: ({ tokensIsLoading }) => tokensIsLoading,
}


const actions = {
    [ACTIONS.FETCH_CLIENTS]({ commit }) {
        commit(MUTATIONS.FETCH_CLIENTS_START)

        return ClientsService.getClients()
            .then(({ data }) => {
                commit(MUTATIONS.FETCH_CLIENTS_END, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.PUT_CLIENTS]({ commit }, params) {
        commit(MUTATIONS.PUT_CLIENTS_START)

        return ClientsService.putClients(params)
            .then((res) => {
                commit(MUTATIONS.PUT_CLIENTS_END, res.data)
            })
            .catch(error => {
                const
                    errObj = error.response.data.errors,
                    errOut = []

                for (let item in errObj) errOut.push(...errObj[item])

                commit(MUTATIONS.PUT_CLIENTS_ERROR, errOut.join('\n'))
                throw new Error(error)
            })
    },

    [ACTIONS.DEL_CLIENTS]({ commit }, id) {
        commit(MUTATIONS.DEL_CLIENTS_START)

        return ClientsService.delClients(id)
            .then(() => {
                commit(MUTATIONS.DEL_CLIENTS_END, id)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.UPDATE_CLIENTS]({ commit }, params) {
        commit(MUTATIONS.UPDATE_CLIENTS_START)

        return ClientsService.updateClients(params.id, params.client)
            .then((data) => {
                commit(MUTATIONS.UPDATE_CLIENTS_END, {
                    id: params.id,
                    data: data.data,
                })
            })
            .catch(error => {
                const
                    errObj = error.response.data.errors,
                    errOut = []

                for (let item in errObj) errOut.push(...errObj[item])

                commit(MUTATIONS.PUT_CLIENTS_ERROR, errOut.join('\n'))
                throw new Error(error)
            })
    },


    [ACTIONS.FETCH_TOKENS]({ commit }) {
        commit(MUTATIONS.FETCH_TOKENS_START)

        return TokensService.getTokens()
            .then(({ data }) => {
                commit(MUTATIONS.FETCH_TOKENS_END, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.DEL_TOKENS]({ commit }, id) {
        commit(MUTATIONS.DEL_TOKENS_START)

        return TokensService.delTokens(id)
            .then(() => {
                commit(MUTATIONS.DEL_TOKENS_END, id)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.CLEAR_ERROR]({ commit }) {
        commit(MUTATIONS.PUT_CLIENTS_ERROR, '')
    },
}


const mutations = {
    [MUTATIONS.FETCH_CLIENTS_START](state) {
        state.clientsIsLoading = true
    },

    [MUTATIONS.FETCH_CLIENTS_END](state, data) {
        state.clients = data
        state.clientsIsLoading = false
    },

    [MUTATIONS.PUT_CLIENTS_START](state) {
        state.addClientError = ''
        // state.globalLoader = true
        state.addClientIsLoading = true
        state.successClient = ''
    },

    [MUTATIONS.PUT_CLIENTS_END](state, data) {
        state.clients.unshift(data)
        // state.globalLoader = false
        state.addClientIsLoading = false
        state.successClient = 'done'
    },

    [MUTATIONS.PUT_CLIENTS_ERROR](state, message) {
        state.addClientError = message
        state.addClientIsLoading = false
        state.successClient = ''
    },

    [MUTATIONS.DEL_CLIENTS_START](state) {
        state.globalLoader = true
    },

    [MUTATIONS.DEL_CLIENTS_END](state, id) {
        state.clients = state.clients.filter(c => c.id !== id)
        state.globalLoader = false
    },

    [MUTATIONS.UPDATE_CLIENTS_START](state) {
        // state.globalLoader = true
        state.addClientError = ''
        state.addClientIsLoading = true
        state.successClient = ''
    },

    [MUTATIONS.UPDATE_CLIENTS_END](state, {id, data}) {

        const client = state.clients.filter(c => c.id === id)[0]
        client.name = data.name
        client.redirect = data.redirect
        // state.globalLoader = false
        state.addClientIsLoading = false
        state.successClient = 'done'

        state.clients = [
            ...(state.clients.filter(c => c.id !== id)),
            client
        ]
    },

    [MUTATIONS.UPDATE_CLIENTS_ERROR](state, message) {
        state.addClientError = message
        state.addClientIsLoading = false
        state.successClient = ''
    },


    [MUTATIONS.FETCH_TOKENS_START](state) {
        state.tokensIsLoading = true
    },

    [MUTATIONS.FETCH_TOKENS_END](state, data) {
        state.tokens = data
        state.tokensIsLoading = false
    },

    [MUTATIONS.DEL_TOKENS_START](state) {
        state.globalLoader = true
    },

    [MUTATIONS.DEL_TOKENS_END](state, id) {
        state.tokens = state.tokens.filter(t => t.id !== id)
        state.globalLoader = false
    },
}


export default {
    state,
    getters,
    actions,
    mutations,
}